import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Chip from 'Chip';

/**
 * 定义 Title 组件
 */
class Title extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pageData: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { title, newsTime, columnLogo, subscribe },
            pageData,
        } = this.props;
        const { page, totalPage } = pageData;

        console.log(subscribe);

        return (
            <div className={styles.titleM}>
                {/* title */}
                <Chip id="50049" type="struct" title="政务幻灯logo" groupName="title" content={columnLogo}>
                    <div className={styles.titImg}>
                        {columnLogo.url === '' ? (
                            <img src={columnLogo.src} width={columnLogo.width} height={columnLogo.height} />
                        ) : (
                            <a href={columnLogo.url} target="_blank">
                                <img src={columnLogo.src} width={columnLogo.width} height={columnLogo.height} />
                            </a>
                        )}
                    </div>
                </Chip>
                <div className={styles.titText}>
                    <div className={styles.title}>
                        <b>{title}</b>
                        <span>
                            (<span className={styles.fz30}>{page}</span>/{totalPage})
                        </span>
                    </div>
                    <div className={styles.date}>{newsTime}</div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Title);
